import { render, staticRenderFns } from "./EditSender.vue?vue&type=template&id=921acdb0&"
import script from "./EditSender.vue?vue&type=script&lang=ts&"
export * from "./EditSender.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports